import React from "react";
import { Link } from "react-router-dom";
import AdminRemoteConfigForm from "./AdminRemoteConfigForm";

export default function AdminRemoteConfigAdd() {
  return (
    <>
      <h1>
        <Link to={"/remote/admin"}>Admin</Link> - Remote - Config Add
      </h1>
      <AdminRemoteConfigForm />
    </>
  );
}
